var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon8(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4647",
    "data-name": "Group 4647",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.154,
    height: 33.814,
    viewBox: "0 0 31.154 33.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1654",
    "data-name": "Rectangle 1654",
    width: 31.154,
    height: 33.814,
    fill: "#f59e0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4646",
    "data-name": "Group 4646",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14057",
    "data-name": "Path 14057",
    d: "M14.237,5.339A14.237,14.237,0,1,0,28.475,19.577,14.243,14.243,0,0,0,14.237,5.339m0,24.916A10.678,10.678,0,1,1,24.916,19.577,10.682,10.682,0,0,1,14.237,30.255M8.9,1.78A1.78,1.78,0,0,1,10.678,0H17.8a1.78,1.78,0,0,1,0,3.559H10.678A1.78,1.78,0,0,1,8.9,1.78M30.625,9.269a1.765,1.765,0,0,1-2.52,0l-1.78-1.78a1.782,1.782,0,1,1,2.52-2.52l1.78,1.78a1.765,1.765,0,0,1,0,2.52M16.017,12.458v7.119a1.78,1.78,0,0,1-3.559,0V12.458a1.78,1.78,0,1,1,3.559,0",
    transform: "translate(0 0)",
    fill: "#f59e0b"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon8);
export default __webpack_public_path__ + "static/media/media_icon8.f94a206c84a7511fcca7562604ec3a07.svg";
export { ForwardRef as ReactComponent };